import {} from "../mod/index.js";
import {} from "../net/index.js";
import { createNodeId } from "../node/createNodeId.js";
import {} from "../node/index.js";
import { nodeKey } from "../node/nodeKey.js";
import {} from "../parameter/index.js";
export function addNode(net, mod, name, input, output) {
    const modId = mod.url.href;
    const id = createNodeId(name);
    const node = { "@type": "Value", "@kind": "Node", modId, id, name };
    const ports = {};
    net.nodeEntries.set(nodeKey(node), { id, modId, name, ports });
    input.map((parameter) => {
        ports[parameter.name] = {
            sign: -1,
            name: parameter.name,
            t: parameter.t,
            isPrincipal: parameter.isPrincipal,
        };
    });
    output.map((parameter) => {
        ports[parameter.name] = {
            sign: 1,
            name: parameter.name,
            t: parameter.t,
            isPrincipal: parameter.isPrincipal,
        };
    });
    return node;
}
//# sourceMappingURL=addNode.js.map